import { Injectable } from '@angular/core';
import { API_HOA_WORKFLOW_PAUSE } from '../util/api.endpoints';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class WorkflowDataService {
    private workflowData: any[] = [];

    setWorkflowData(data: any[]) {
        this.workflowData = data;
    }

    getWorkflowData() {
        return this.workflowData;
    }

    clearWorkflowData() {
        this.workflowData = [];
    }
}